import {
    BodyLargeRegular,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Shadows,
    YStack,
} from 'smoothie';

import useConnectQuilttInstitution from '../../../holistic/hooks/useConnectQuilttInstitution';

const BillsNotFound = () => {
    const { connectInstitution } = useConnectQuilttInstitution();

    return (
        <YStack
            gap={32}
            padding={20}
            borderRadius="$5"
            borderWidth={1}
            borderColor="$gray200"
            flex={1}
            justifyContent="space-between"
            backgroundColor="$white"
            {...Shadows.SMALL}
        >
            <YStack width="100%" gap={8}>
                <BodyLargeRegular>No bills found...yet</BodyLargeRegular>

                <BodyMediumRegular color="$gray1000">
                    Make sure you&apos;ve linked the accounts and credit cards
                    where you pay your bills
                </BodyMediumRegular>
            </YStack>

            <Button
                text="Link accounts"
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                onPress={connectInstitution}
            />
        </YStack>
    );
};

export default BillsNotFound;
